module.exports = __webpack_public_path__ + "img/img7.13f3598a.png";